import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import StickyCTA from "@/components/site/StickyCTA";
import ScrollToTop from "@/components/site/ScrollToTop";
import PromoSplash from "@/components/site/PromoSplash";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Classes from "@/pages/Classes";
import Services from "@/pages/Services";
import Instructors from "@/pages/Instructors";
import FounderProfile from "@/pages/FounderProfile";
import FacultyProfile from "@/pages/FacultyProfile";
import Awards from "@/pages/Awards";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import BookTrial from "@/pages/BookTrial";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function Layout({ children }) {
  useLocation();
  return (
    <>
      <Navbar />
      <main className="min-h-screen">{children}</main>
      <Footer />
      <StickyCTA />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/classes" element={<Classes />} />
            <Route path="/services" element={<Services />} />
            <Route path="/instructors" element={<Instructors />} />
            <Route path="/instructors/:id" element={<FounderProfile />} />
            <Route path="/faculty/:id" element={<FacultyProfile />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/book-trial" element={<BookTrial />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </Layout>
        <Toaster theme="dark" position="bottom-right" richColors duration={2000} />
        <PromoSplash />
      </BrowserRouter>
    </div>
  );
}

export default App;
